import {Component, Input} from '@angular/core';
import {TextServiceProvider} from '../../../modules/core/services/text-service/text-service';

@Component({
  selector: 'sellions-indicator-bar',
  templateUrl: 'sellions-indicator-bar.html'
})
export class SellionsIndicatorBarComponent {
  @Input()
  private percentIndicators;
  @Input()
  private vertical: boolean = false;
  @Input()
  private passedIndicators;

  constructor(public textService: TextServiceProvider) {
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-indicator-bar/sellions-indicator-bar.ts